export const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';
export const UPDATE_QUERY_PARAM = 'UPDATE_QUERY_PARAM';

export const setQueryParams = (payload) => {
    return {
    type: SET_QUERY_PARAMS,
    payload : payload
  }
}

export const updateQueryParams = (params) => {
    return{
      type: UPDATE_QUERY_PARAM,
      payload : params
    }
}
